import { Component, EventEmitter, Input, OnChanges, OnInit, Output, } from "@angular/core";
import { FormGroup,  FormBuilder, Validators } from "@angular/forms";
import { AdminService } from "../../../../services/admin.service";
import { apiUrl } from "../../../../global/global";
import { ToastrService } from "ngx-toastr";
import * as CONSTANT from "../../../../services/constants";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-step-two",
  templateUrl: "./step-two.component.html",
  styleUrls: ["./step-two.component.css"]
})
export class StepTwoComponent implements OnInit {
  isStepper;
  @Input() filledData: any;
  @Input() isAdd: any;
  @Output() valueChange = new EventEmitter();
  @Output() stepperChange = new EventEmitter();
  @Output() changeDetected: EventEmitter<any> = new EventEmitter<any>();
  objectProp: any;
  // form
  jobPostId;
  form: FormGroup;
  showError: boolean = false; 
  showAmountError: boolean = false; 
  showAmountLessError: boolean = false; 
  showRange: boolean = true; 
  allBenefits:any=[];
  allSupply:any=[]; 
  constructor( private formBuilder: FormBuilder, private api: AdminService, private toastrService: ToastrService,private route: ActivatedRoute) {
    this.form = this.formBuilder.group({ 
      id: [""],
      payOption: ["Range", Validators.compose([Validators.required])],
      minimum: [""],
      maximum: [""],
      price: [""],
      rate: ["", Validators.compose([Validators.required])],
      benefitsIds: [""],
      supplementalPayId: [""],
      steps: [""],
    })
    
   }
 
   back() {
    this.stepperChange.emit({ step : 1 });
  }
  ngOnChanges(filledData: any) { 

    if(filledData != undefined){
      this.filledData = filledData.filledData.currentValue;
      this. getSelectedBenefits();
      this. getSelectedSupply();
      this.form.patchValue({
        ...this.filledData?.JobPost,
        id:this.filledData?.JobPost?.id,
        payOption:this.filledData?.JobPost.payOption,
        minimum:this.filledData?.JobPost.minimum,
        maximum:this.filledData?.JobPost.maximum,
        rate:this.filledData?.JobPost.rate,
      })
    }
  }
  getSelectedBenefits() {
    if (this.allBenefits.length > 0 && this.filledData != undefined){
      this.allBenefits.map((ben)=> {
        this.filledData.JobPostBenefits.map((Benefits) => {
          if(ben.id == Benefits.benefitsId) {
            ben['selected'] = true;
          }
        }) 
      })
    } 
  }
  getSelectedSupply() {
    if (this.allSupply.length > 0 && this.filledData != undefined){
      this.allSupply.map((sup)=> {
        this.filledData.supplementalPay.map((pay) => {
          if(sup.id == pay.supplementalPayId) {
            sup['selected'] = true;
          }
        }) 
      })
    } 
  }
  ngOnInit(): void {    
    this.jobPostId = this.route.snapshot.paramMap.get('id'); 
    if (this.filledData != undefined){
      
    this.form.patchValue({
      id:this.filledData?.JobPost?.id ||this.jobPostId,
    })
    if (this.filledData?.JobPost?.payOption == null) {
      this.form.patchValue({
      payOption:"Range"
      })
    }
  }
    if(this.filledData != undefined && this.filledData?.JobPost?.payOption == "Range"){
      this.showRange= true;
    } else{
      this.showRange= false;
    }
    this.getBenifit();
    this.getSupply();
    
  } 
  // get benefits
  getBenifit(){
  this.api.stopLoader(); 
    this.api.getDatas(apiUrl._getBenefits)
    .subscribe(async (res) => {
      this.allBenefits = res.data.data;
      this.getSelectedBenefits();
     })
  }
  // selected benefits
  selectedBenefits(i,event){
    if (this.allBenefits[i]["selected"] == true) {
      this.allBenefits[i]["selected"] = false
    } else {
      this.allBenefits[i]["selected"] = true
    }
  }
//  get Supply
  getSupply(){
  this.api.stopLoader(); 
    this.api.getDatas(apiUrl._getSupplements)
    .subscribe(async (res) => {
      this.allSupply = res.data.data;
      this.getSelectedSupply();
     })
  }
  // selected supply
  selectedSupply(i,event){
    if (this.allSupply[i]["selected"] == true) {
      this.allSupply[i]["selected"] = false 
    } else {
      this.allSupply[i]["selected"] = true 
    }
  }
  selectPayOption(event){ 
    if(event.target.value == "Range"){
      this.showRange= true;
      this.form.controls['price'].reset()
    } else{
      this.showRange= false;
    }
  }
  onSubmit(){ 
    let benefitsIds:any=[];
    this.allBenefits.map((benefit)=>{  
      if (benefit["selected"] == true){
      benefitsIds.push({"benefitsId":benefit.id})
    }
    })
    let supplemental :any=[];
    this.allSupply.map((supply) => {
      if (supply["selected"] == true){
      supplemental.push({"supplementalPayId":supply.id})
      }
    })   
    if(this.showRange == false && this.form.value.price == "" || this.form.value.price == "0"){
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 3000);
      return
    }
    if(this.showRange == true && this.form.value.minimum == null || this.form.value.minimum == "" || this.form.value.minimum == "0"){
      this.showAmountError = true;
      setTimeout(() => {
        this.showAmountError = false;
      }, 3000);
      return
    }
    if(this.showRange == true && this.form.value.maximum == null || this.form.value.maximum == "0"){
      this.showAmountError = true;
      setTimeout(() => {
        this.showAmountError = false;
      }, 3000);
      return
    }
    if(Number(this.form.value.minimum) > Number(this.form.value.maximum)){
      this.showAmountLessError = true;
      setTimeout(() => {
        this.showAmountLessError = false;
      }, 3000);
      return
    }
    this.form.patchValue({
      benefitsIds:benefitsIds,
      supplementalPayId:supplemental,
      steps:2,
    }) 
   
    if(this.form.valid){
      this.api.putData(apiUrl._getJobs, this.removeEmptyFiled(this.form))
      .subscribe(async (res) => { 
        this.valueChange.emit({ data: res.data.result.payload });
      })
      
    } else{
      this.showError = true;this.showAmountLessError = true;
      setTimeout(() => {
        this.showError = false;this.showAmountLessError = false;
      }, 3000);
    }
  }
  
  removeEmptyFiled(form){
    const formValues = form.value;
    const formKeys = Object.keys(formValues);
    if (formKeys.length) {
      for (let i = 0; i < formKeys.length; i++) {
        if (
          formValues[formKeys[i]] == null ||
          formValues[formKeys[i]] == undefined ||
          formValues[formKeys[i]] == ""
        ) {
          delete formValues[formKeys[i]];
        }
      }
    }
  
    return formValues
  }
  // check if only number
  preventNumbers(event): boolean { 
    event = (event) ? event : window.event;
    var charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    return true;
  }
}
